import useB2bUser from "~/composables/UserManagement/useB2bUser";
import paths from "~/constants/paths";

export default defineNuxtRouteMiddleware(async (to) => {
  const userToken = useCookie("hs-token");

  if (!userToken.value) return;

  const userDeletionPending = ref(false);

  const { user } = useB2bUser();

  userDeletionPending.value =
    user.value?.delete_request?.is_deletion_pending || false;

  if (userDeletionPending.value) {
    const protectedPages = {
      [paths.account.index]: true,
      [paths.account.orders.active]: true,
      [paths.account.orders.inactive]: true,
      [paths.account.details]: true,
      [paths.account.addresses]: true,
      [paths.account.changePassword]: true,
      [paths.wishList]: true,
      [paths.checkout]: true,
      [paths.orderPlaced]: true,
      [paths.paymentFailed]: true,
      [paths.saved_cart]: true,
    };

    if (protectedPages[to.path]) {
      return navigateTo(paths.accountDeletionPending);
    }
  } else if (to.path === paths.accountDeletionPending) {
    return navigateTo(paths.home);
  }
});
